export class NGIssueTypeV2 {

    public title: string = '';
    public id: string = '';
    public isSubType: boolean = false;
    public parentTypeId: string = '';
    public parentTypeTitle: string = '';
    public subtypes: NGIssueTypeV2[] = [];

    public static fromAutodeskJSON(json: any): NGIssueTypeV2
    {
        let nGIssueType = new NGIssueTypeV2();
        nGIssueType.title = json.title;
        nGIssueType.id = json.id;
        nGIssueType.subtypes = json.subtypes.map((s) => {
            let ngIssueSubType = new NGIssueTypeV2();
            ngIssueSubType.id = s.id;
            ngIssueSubType.title = s.title;
            ngIssueSubType.isSubType = true;
            ngIssueSubType.parentTypeId = nGIssueType.id;
            ngIssueSubType.parentTypeTitle = nGIssueType.title;
            return ngIssueSubType;
        }); 
        
        return nGIssueType;
    }
}